import { useSyncLayoutWithRoute } from "../../hooks/useSyncLayoutWithRoute";

const LayoutSync = () => {
  useSyncLayoutWithRoute();
  return null;
};

export default LayoutSync;
